/*
 *
 * Package: `@dbh/react-dates-field-theme`.
 *
 */const THEME_KEY_REACT_DATES="reactDates";const modifyReactDatesTheme=a=>{let{colors:{black:b},spacing:{sp8:c,sp2:d}}=a;return {[THEME_KEY_REACT_DATES]:{datePickerWrapper:{top:c,borderRadius:d},datePickerControllerWrapper:{width:"auto",calenderWidth:"auto",boxShadow:"0 1px 6px 0 "+b}}}};

export { THEME_KEY_REACT_DATES, modifyReactDatesTheme as default };
